/* Omriant — editorial scroll reveal.
   Opacity/transform only, so it can never cause layout shift.
   Fully skipped when the visitor asks for reduced motion.
   If this file fails to load, nothing is hidden: the reveal CSS is gated on .lux-ready. */
(function () {
  'use strict';

  if (window.__omriantLuxBound) return;
  window.__omriantLuxBound = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function revealAll() {
    document.querySelectorAll('[data-lux]').forEach(function (el) {
      el.classList.add('is-in');
    });
  }

  if (reduce.matches || !('IntersectionObserver' in window)) {
    document.documentElement.classList.remove('lux-ready');
    revealAll();
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  function scan() {
    document.querySelectorAll('[data-lux]:not([data-lux-bound])').forEach(function (el) {
      el.setAttribute('data-lux-bound', '');
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  /* Theme editor re-renders sections without a page load. */
  document.addEventListener('shopify:section:load', scan);

  /* If the visitor turns reduced motion on mid-session, stop animating and show everything. */
  var onChange = function (e) {
    if (!e.matches) return;
    document.documentElement.classList.remove('lux-ready');
    revealAll();
  };
  if (reduce.addEventListener) reduce.addEventListener('change', onChange);
  else if (reduce.addListener) reduce.addListener(onChange);

  /* Safety net: if something blocks the observer, never leave content invisible. */
  window.setTimeout(revealAll, 4000);
})();
